var _rect, _rect2, _rect3, _rect4, _rect5, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCorporate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 22.1768,
    y: 24.5996,
    width: 2.38807,
    height: 12.3383,
    fill: "#E5813B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 22.5742,
    y: 12.8584,
    width: 1.39304,
    height: 13.1344,
    transform: "rotate(90 22.5742 12.8584)",
    fill: "#E5813B"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 23.1719,
    y: 11.0674,
    width: 1.39304,
    height: 14.5274,
    transform: "rotate(90 23.1719 11.0674)",
    fill: "#E5813B"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 36.0605,
    y: 4.5,
    width: 1.39304,
    height: 14.5274,
    transform: "rotate(75.793 36.0605 4.5)",
    fill: "#E5813B"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 37.3008,
    y: 36.9385,
    width: 2.98509,
    height: 29.6518,
    transform: "rotate(90 37.3008 36.9385)",
    fill: "#E43F36"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.3662 9.25973L34.9135 6.68945V37.1373H24.3662V9.25973ZM31.4316 8.7789L33.6206 8.28139V13.2565H31.4316V8.7789ZM30.536 8.87841L28.347 9.37592V13.2565H30.536V8.87841ZM27.551 9.57493L25.3619 10.0724V13.2565H27.551V9.57493ZM27.551 14.2517H25.3619V18.0328H27.551V14.2517ZM25.3619 19.0277H27.551V22.8088H25.3619V19.0277ZM27.551 23.8038H25.3619V27.5849H27.551V23.8038ZM25.3619 28.5797H27.551V32.3608H25.3619V28.5797ZM27.551 33.1575H25.3619V36.9386H27.551V33.1575ZM28.3471 14.2517H30.5361V18.0328H28.3471V14.2517ZM30.5361 19.0277H28.3471V22.8088H30.5361V19.0277ZM28.3471 23.8038H30.5362V27.5849H28.3471V23.8038ZM30.5362 28.5797H28.3471V32.3608H30.5362V28.5797ZM28.3471 33.1575H30.5362V36.9386H28.3471V33.1575ZM33.5213 14.2517H31.3322V18.0328H33.5213V14.2517ZM31.3322 19.0277H33.5213V22.8088H31.3322V19.0277ZM33.5214 23.8038H31.3323V27.5849H33.5214V23.8038ZM31.3323 28.5797H33.5214V32.3608H31.3323V28.5797ZM33.5214 33.1575H31.3323V36.9386H33.5214V33.1575Z",
    fill: "#E43F36"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0371 14.6484H22.1765V37.1361H10.0371V14.6484ZM11.8284 16.2407H14.2165V24.3999H11.8284V16.2407ZM14.2165 26.1908H11.8284V34.35H14.2165V26.1908ZM15.0123 16.2407H17.4003V24.3999H15.0123V16.2407ZM17.4003 26.1908H15.0123V34.35H17.4003V26.1908ZM18.3955 16.2407H20.7836V24.3999H18.3955V16.2407ZM20.7837 26.1908H18.3956V34.35H20.7837V26.1908Z",
    fill: "#E43F36"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCorporate);
export default __webpack_public_path__ + "static/media/icon-corporate.2f83218d80d2e5d8da9e619941c92a89.svg";
export { ForwardRef as ReactComponent };